import { render, staticRenderFns } from "./LeadForm.vue?vue&type=template&id=0fbfe01c&scoped=true"
import script from "./LeadForm.vue?vue&type=script&lang=js"
export * from "./LeadForm.vue?vue&type=script&lang=js"
import style0 from "./LeadForm.vue?vue&type=style&index=0&id=0fbfe01c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfe01c",
  null
  
)

export default component.exports